import React, { Component } from 'react';
import { Button, BottomNav } from 'components';
import background from 'assets/images/heroGraphic.png';
import './Homepage.scss';
import ultilitiesService from 'shared/util/ultilitiesService';
import { FormattedMessage, injectIntl } from 'react-intl';
import { LayoutWithBannerNavbarFooter } from 'layouts';
import { PATH, STATUS } from 'shared/constants';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { getRTL } from 'shared/redux/selectors';
import { withRouter } from 'react-router-dom';
import {
  toggleLanguage,
  // getStepStatus
} from 'shared/redux/actions';
import arrow from 'assets/icons/next.svg';
import trackEvent from 'components/TrackEvent/TrackEvent';
import {
  // eventCallUs, 
  eventStartInvestmentAdvice, eventResumeInvestmentAdvice, eventLearnMore,
} from 'components/TrackEvent/constEvent';

const statusBarClass = 'status-bar--home';

class Homepage extends Component {
  componentDidMount() {
    document.body.classList.add(statusBarClass);
  }

  componentWillUnmount() {
    document.body.classList.remove(statusBarClass);
  }

  render() {
    const {
      intl, history, currentLocale, stepStatus, isRtl,
    } = this.props;

    const allStepCompleted = stepStatus.filter(item => item.status === STATUS.COMPLETED).length === stepStatus.length;
    const inCompleted = stepStatus.filter((item) => {
      if (item.status === STATUS.INCOMPLETE || item.status === STATUS.COMPLETED) {
        return true;
      }
      return false;
    }).length >= 1;

    return (
      <LayoutWithBannerNavbarFooter
        rightButton={ultilitiesService.locale(currentLocale)}
        onRightClick={() => history.push(PATH.LANGUAGE)}
        background={background}
        className="nw-page-home"
        footerChildren={(
          <BottomNav
            rtl={isRtl}
            leftButton={(
            <>
              <FormattedMessage id="journey.learnMore" />
              <span className="arrow"><img src={arrow} alt="Icon arrow next" /></span>
            </>
          )}
            onLeftClick={() => {
              history.push(PATH.ABOUT_INVESTMENT_ADVICE);
              trackEvent(eventLearnMore(currentLocale, intl.formatMessage({ id: 'journey.learnMore' })));
            }}
          />
        )}
      >
        <h2><FormattedMessage id="home.title" /></h2>
        <p><FormattedMessage id="home.desc" /></p>
        <Button
          value={intl.formatMessage({
            // eslint-disable-next-line no-nested-ternary
            id: allStepCompleted ? 'journey.reviewInvestment' : inCompleted ? 'home.continueInvestAdvice' : 'home.startInvestAdvice',
          })}
          onButtonClick={() => {
            this.props.history.push(PATH.JOURNEY_OVERVIEW);
            if (!allStepCompleted) {
              if (inCompleted) {
                trackEvent(eventResumeInvestmentAdvice(currentLocale, intl.formatMessage({ id: 'home.continueInvestAdvice' })));
              } else {
                trackEvent(eventStartInvestmentAdvice(currentLocale, intl.formatMessage({ id: 'home.startInvestAdvice' })));
              }
            }
          }}
          isPrimary
          isBig
        />

        {/* COB link */}
        <a href="/cob-front/" className="nw-button nw-button--outline nw-button--big" rel='noopener noreferrer' title={intl.formatMessage({ id: 'home.onlineApplication' })}>
          {intl.formatMessage({ id: 'home.onlineApplication' })}
        </a>
        <p>{intl.formatMessage({ id: 'home.openAnInvestment' })}</p>

        <hr />

        {/* <Button value={intl.formatMessage({ id: 'home.callRelationshipManager' })} isOutlineButton isBig /> */}
        {/* <a
          href="tel:+96522248000"
          className="nw-button nw-button--outline nw-button--big"
          onClick={() => {
            trackEvent(eventCallUs(currentLocale));
          }}
        >
          {intl.formatMessage({ id: 'home.callUsAt' })}
        </a> */}
        <p>
          {intl.formatMessage({ id: 'home.forEnquiry' })}
          <br />
          {intl.formatMessage({ id: 'home.dayTime' })}
        </p>
      </LayoutWithBannerNavbarFooter>
    );
  }
}

const mapStateToProps = state => ({
  stepStatus: state.rootReducer.stepStatus,
  currentLocale: state.rootReducer.language.locale,
  isRtl: getRTL(state.rootReducer),
});

const mapDispatchToProps = ({
  onSwitchLanguage: toggleLanguage,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(Homepage)));
